module.exports = __webpack_public_path__ + "static/media/Publication.312f96cd.svg";